import { LocaleKeys } from '../../../../locale/translation-types'

export enum TaughtLevelEnum {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED'
}

export const taughtLevelEnumMapping: Record<string, LocaleKeys> = {
  [TaughtLevelEnum.BEGINNER]: 'taught.level.enum.beginner',
  [TaughtLevelEnum.INTERMEDIATE]: 'taught.level.enum.intermediate',
  [TaughtLevelEnum.ADVANCED]: 'taught.level.enum.advanced'
}
